import { useState, useEffect } from "react";
import {getTreatmentHistoryDetail} from "../../api/searchs/treatmentHistoryResultApi";
import {errorStatusHandle} from "../../utils/error-utils";
import {useDispatch} from "react-redux";
import {clearPageLoading, setPageLoading} from "../../store/actions";
import {getSearchInspectionHistoryResultSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";

const useSearchTreatmentHistoryDetail = (workflowId, treatmentId, params = {}) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useState({});
  const [inspection, setInspection] = useState({});

  useEffect(() => {
    dispatch(setPageLoading());
    getSearchInspectionHistoryResultSettings().then((pageSettings) => {
      dispatch(setPageSettings(pageSettings));
    }).catch(e => {
      errorStatusHandle(e.response);
    });
    getTreatmentHistoryDetail(workflowId, treatmentId, params).then((response) => {
      setSearchParams(response.search_params);
      setInspection(response.inspection);
    }).catch(e => {
      errorStatusHandle(e.response);
    }).finally(() => {
      dispatch(clearPageLoading())
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchParams, inspection };
}

export { useSearchTreatmentHistoryDetail }